import { createBrowserRouter } from "react-router-dom";
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CreateUser from './pages/User/CreateUser';
import ChangePassword from './pages/ChangePassword';
import ListUser from './pages/User/ListUser';
import EditUser from './pages/User/EditUser';
import ShowUser from './pages/User/ShowUser'; // ShowUser component
import ListSports from "./pages/Sports/ListSports";
import AddSport from "./pages/Sports/AddSports";
import ListActivities from "./pages/Activity/ListActivity";
import ShowActivity from "./pages/Activity/ShowActivity";
import EditSport from "./pages/Sports/EditSports";
import PolicyManager from "./pages/Content/PolicyManager";
import SuggestionSports from "./pages/Sports/SuggestionSports";
import ListReviews from "./pages/reviews/ListReviews";
import ListReports from "./pages/Report/ListReport";

// const base = "/TM/Go4it/"; // Set base path for deployment

const router = createBrowserRouter(
  [
    {
      // path: base,
      children: [
        { path: "", element: <Login /> },
        { path: "dashboard", element: <Dashboard /> },
        { path: "change-password", element: <ChangePassword /> },
        { path: "create-user", element: <CreateUser /> },
        { path: "user", element: <ListUser /> },
        { path: "edit-user", element: <EditUser /> },
        { path: "sport", element: <ListSports /> }, 
        { path: "create-sport", element: <AddSport /> },
        { path: "activity", element: <ListActivities /> },
        
        // Dynamic route for showing user details with user_id and language
        {
          path: "user/:user_id", 
          element: <ShowUser />,
        },
         {path:"/activity/show-activity/:activity_id/:user_id", element:<ShowActivity/>},
         {path:"/sport/edit-sport/:sport_id", element:<EditSport/>},
         {path: "policy", element: <PolicyManager/>},
         { path: "suggestion-sport", element: <SuggestionSports /> },
         {path: "reviews", element: <ListReviews/>},
         {path: "reports", element: <ListReports/>}
      ],
    },
  ],
);

export default router;
